module.exports = __webpack_public_path__ + "img/settings.b77c2026.svg";